<template>
  <modal name="send-invitation-modal"
        @before-open="handleBeforeOpen"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Ընտրել նախընտրած մասնակիցներին</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('send-invitation-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1" ref="searchBlock">
              <label for="procurement-code-hy"><p class="mb-1">ՀՎՀՀ կամ մասնակցի անվանումը</p></label>
              <input 
                v-model="invitation.specificUserName"
                @input="searchParticipants"
                type="text"
                class="form-control"
                id="procurement-code-hy"
              >
              <div v-if="isSearching"
                    class="spinner-border spinner-border-sm position-absolute"
                    style="top: 7px; left: -12px;"
                    role="status"></div>
              <ul v-if="showSearchResult"
                  @v-click-outside="() => alert()"
                  class="position-absolute border rounded-bottom w-75 bg-white shadow"
                  style="cursor: pointer; z-index: 99; overflow-y: auto; list-style-type: none; padding: 0!important;">
                <template v-if="searchResults.length">
                  <li
                      v-for="(item, index) in searchResults"
                      :key="index"
                      @click="() => {selectedParticipants.filter(participant => item.id === participant.id).length===0 && selectFromSearch(item)}"
                      class="searchItem p-3"
                      :class="{'border-top': index > 0, 'bg-secondary text-white': selectedParticipants.filter(participant => item.id === participant.id).length>0}">
                    >
                    <font-awesome-icon icon="user-tie" class="mr-2"/>
                    <!--                    <span class="font-weight-bold">{{ item.query }}</span>-->
                    <span>{{ item.tin }}</span>
                    <span class="mr-2"> ({{ item.name.hy }}) </span>
                  </li>
                </template>
                <li v-else class="p-3">
                  <span > Որոնման արդյունքում ոչինչ չի գտնվել </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="mb-3 pl-1">
              <table class="VueTables__table table table-bordered table-hover" style="overflow: hidden;">
                <thead>
                    <tr>
                      <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                          <div class="row justify-content-center">
                            <span class="VueTables__heading">Հ/Հ</span>
                          </div>
                      </th>
                      <th tabindex="0" title="" class="VueTables__sortable " style="position: relative;">
                          <div class="row justify-content-center">
                            <span class="VueTables__heading">ՀՎՀՀ</span>
                          </div>
                      </th>
                      <th tabindex="0" title="" class="VueTables__sortable ">
                          <div class="row justify-content-center">
                            <span class="VueTables__heading">Անվանումը</span>
                          </div>
                      </th>
                      <th tabindex="0" title="" class="VueTables__sortable ">
                          <div class="row justify-content-center">
                            <span class="VueTables__heading">Հեռախոսահամար</span>
                          </div>
                      </th>
                      <th tabindex="0" title="" class="VueTables__sortable ">
                          <div class="row justify-content-center">
                            <span class="VueTables__heading">Էլ. Հասցե</span>
                          </div>
                      </th>
                      <th tabindex="0" title="" class="VueTables__sortable ">
                          <div class="row justify-content-center">
                            <span class="VueTables__heading">Հասցե</span>
                          </div>
                      </th>
                      <th tabindex="0" title="" class="VueTables__sortable ">
                          <div class="row justify-content-center">
                          </div>
                      </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(participant, index) in selectedParticipants" :key="index" class="VueTables__row ">
                      <td tabindex="0" class="">{{index + 1}}</td>
                      <td tabindex="0" class="">{{participant.tin}}</td>
                      <td tabindex="0" class="">{{participant.name.hy}}</td>
                      <td tabindex="0" class="">{{participant.phone}}</td>
                      <td tabindex="0" class="">{{participant.email}}</td>
                      <td tabindex="0" class="">{{participant.address}}</td>
                      <td tabindex="0" class="">
                        <a v-tooltip="'Հեռացնել'" @click.prevent="deleteParticipant(participant.id)" class="" href="">
                          <i class="mdi mdi-trash-can-outline text-danger font-18"></i>
                        </a>
                      </td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button :disabled="loading" @click="save" class="btn btn-sm btn-light mr-3">
        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Ուղարկել
      </button>
    </div>
  </modal>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'SendInvitationModal',
    components: {  },
    data() {
      const currentDate = new Date()
      const today = this.addWorkDays(currentDate, 2);
      const formattedDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
      return {
        data: [
          {code: '1102021313', name: 'Ideal hamakarg'},
          {code: '1104564313', name: 'Nor Tun'},
          {code: '1106332423', name: 'Domus'},
        ],
        loading: false,
        showSearchResult: false,
        searchTimeoutId: null,
        searchResults: [],
        selectedParticipants: [],
        isSearching: false,
        invitation: {
          publish: true,
          invitationAddressee: 'all-matching-users',
          winnerDeterminingType: 'byLot',
          opening_time: '',
          opening_date: formattedDate,
          specificUserName: '',
        },
      }
    },
    validations() {
      const rules = {
        invitation: {
          publish: {required},
          invitationAddressee: {required},
          winnerDeterminingType: {required},
          opening_date: {},
          opening_time: {},
        },
      }
      return rules
    },
    mounted() {
      document.addEventListener("click", this.onClickOutside);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.onClickOutside);
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
      currentOrganized() {
        return this.$store.getters['organizeOnePerson/currentOrganized']
      },
    },
    methods: {
      onClickOutside(event) {
        const { searchBlock } = this.$refs;
        if (!searchBlock || searchBlock.contains(event.target)) return;
        this.showSearchResult = false;
      },
      handleBeforeOpen(event) {
        this.publish = event.params
      },
      deleteParticipant(participantId){
        const optionIndex = this.selectedParticipants.findIndex(participant => participant.id === participantId)
        this.selectedParticipants.splice(optionIndex, 1)
      },
      selectFromSearch(searchItem) {
        this.invitation.specificUserName = '';
        this.selectedParticipants.push(searchItem)
        setTimeout(() => {
          this.showSearchResult = false
        }, 150)
      },
      searchParticipants(event) {
        this.searchResults = []
        const query = event.target.value
        if(query.length < 3) {
          if(this.showSearchResult) this.showSearchResult = false
          if(this.isSearching) this.isSearching = false
          if(this.searchTimeoutId) clearTimeout(this.searchTimeoutId)
          return
        }

        if(this.searchTimeoutId) {
          clearTimeout(this.searchTimeoutId)
        }
        this.searchTimeoutId = setTimeout(() => {
          this.isSearching = true
          setTimeout(() => {
            this.$client.get('user/search', {
              params: {
                q: query
              }
            }).then(({data}) => {
              data.forEach((item) => {
                const objItem = {
                  query,
                  id: item.id,
                  tin: item.tin,
                  name: item.name,
                  address: `${item.organisation.region.hy} ${item.organisation.city.hy}  ${item.organisation.address.hy}`,
                  phone: item.phone,
                  email: item.email,
                }
                this.searchResults.push(objItem);
              })
            }).catch(e => {
              console.log('error from participant search')
            })
            this.isSearching = false
            this.showSearchResult = true
          }, 400)
        }, 500)
      },
      isFutureDate(date) {
          const currentDate = new Date();
          const today = this.addWorkDays(currentDate, 2);
          return date < today;
      },
      addWorkDays(startDate, days) {
        if(isNaN(days)) {
            console.log("Value provided for \"days\" was not a number");
            return
        }
        if(!(startDate instanceof Date)) {
            console.log("Value provided for \"startDate\" was not a Date object");
            return
        }
        var dow = startDate.getDay();
        var daysToAdd = parseInt(days);
        if (dow === 0)
            daysToAdd++;
        if (dow + daysToAdd >= 6) {
            var remainingWorkDays = daysToAdd - (5 - dow);
            daysToAdd += 2;
            if (remainingWorkDays > 5) {
                daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
                if (remainingWorkDays % 5 === 0)
                    daysToAdd -= 2;
            }
        }
        startDate.setDate(startDate.getDate() + daysToAdd);
        return startDate;
      },
      save() {
        this.loading = true;
        const requestData = [];
        this.selectedParticipants.forEach((participant) => {
          const itemObj = {
            organize_id: this.$route.params.id,
            client_id: this.me.id,
            provider_id: participant.id,
            is_itender: false,
          }
          requestData.push(itemObj)
        })
        this.$store.dispatch('suggestions/create', requestData).then(({data}) => {
          if(data.status){
            this.publish()
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Ինչ որ բան այն չէ',
              text: 'Կրկին փորձեք!'
            })
          }
        }).catch(e => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Ինչ որ բան այն չէ',
            text: 'Կրկին փորձեք!'
          })
        })
      }
    }
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
  /deep/ .vm--modal {
    top: 1rem !important;
    left: unset !important;
    width: 960px !important;
    height: 80% !important;
    margin: auto;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>